"use client";

import { motion } from "motion/react";
import { type ReactNode } from "react";

import { cn } from "../../utils";

export interface Social {
  name: string;
  icon: ReactNode;
  url: string;
  label: string;
}

export interface SocialsProps {
  socials: Social[];
  className?: string;
}

// The component has dark mode only variant only used in landing pages
export const Socials: React.FC<SocialsProps> = ({ socials, className }) => {
  return (
    <ul className={cn("ui:flex ui:gap-4", className)}>
      {socials.map((social) => (
        <li key={social.name}>
          <motion.a
            initial="rest"
            rel="noopener"
            target="_blank"
            href={social.url}
            whileHover="hover"
            aria-label={social.label}
            transition={{ duration: 0.25, ease: "easeInOut" }}
            className="ui:flex ui:h-12 ui:min-w-12 ui:items-center ui:justify-center ui:overflow-hidden ui:bg-[rgba(243,243,243,0.1)] ui:px-3.5 ui:text-xl ui:text-white ui:transition-colors ui:hover:bg-[#282828]"
            variants={{
              rest: {
                maxWidth: "48px",
              },
              hover: {
                maxWidth: "200px",
              },
            }}
          >
            <motion.span
              transition={{ duration: 0.25, ease: "easeInOut" }}
              className="ui:flex ui:h-full ui:items-center ui:overflow-hidden ui:border-r-[rgba(252,252,252,0.1)] ui:text-sm ui:whitespace-nowrap"
              variants={{
                rest: {
                  opacity: 0,
                  maxWidth: 0,
                  paddingRight: 0,
                  marginRight: 0,
                  borderRightWidth: 0,
                },
                hover: {
                  opacity: 1,
                  maxWidth: "150px",
                  paddingRight: "14px",
                  marginRight: "14px",
                  borderRightWidth: "1px",
                },
              }}
            >
              {social.label}
            </motion.span>

            {social.icon}
          </motion.a>
        </li>
      ))}
    </ul>
  );
};
